import {default as WebLayout} from './WebLayout-Component'
export default WebLayout